var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRunning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.165,
    height: 114.125,
    viewBox: "0 0 104.165 114.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.194,
    y1: 0.21,
    x2: 1.22,
    y2: 1.46,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Icon_awesome-running",
    x: 0,
    y: 0,
    width: 104.165,
    height: 114.125,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_awesome-running)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-running-2",
    "data-name": "Icon awesome-running",
    d: "M28.224,9.961a4.981,4.981,0,1,0-4.981-4.981A4.981,4.981,0,0,0,28.224,9.961ZM11.8,32.942l-1.536,3.582H3.32a3.32,3.32,0,1,0,0,6.641h8.036a4.97,4.97,0,0,0,4.577-3.018l.912-2.129-1.107-.654A9.881,9.881,0,0,1,11.8,32.942Zm28.048-9.7H35.276l-2.7-5.525a9.956,9.956,0,0,0-6.41-5.286l-7.375-2.194A9.919,9.919,0,0,0,10.4,12.016L6.282,15.171a3.32,3.32,0,0,0,4.041,5.269l4.118-3.155a3.231,3.231,0,0,1,2.622-.637l1.525.453L14.7,26.169A6.658,6.658,0,0,0,17.43,34.5l8.818,5.206-2.85,9.1A3.32,3.32,0,1,0,29.734,50.8l3.283-10.486a5,5,0,0,0-2.245-5.644l-6.354-3.75,3.249-8.123,2.1,4.3a5.011,5.011,0,0,0,4.473,2.79h5.6a3.32,3.32,0,1,0,0-6.64Z",
    transform: "translate(25.5 25.5)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunning);
export default __webpack_public_path__ + "static/media/running.287240c5c94e31ad903989910413421e.svg";
export { ForwardRef as ReactComponent };